// extracted by mini-css-extract-plugin
export default {"emoji-list":"EmojiList_emoji-list__+Nwwo"};